import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { STATUS_TYPES, StatusType } from '../../types/status.types';
import { MatChipsModule } from '@angular/material/chips';
import { NgClass } from '@angular/common';
import { TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { TranslationInfo } from '@shared/types/translation-info';

const CHIP_BASE_STYLE_CLASS: string = "status-chip";

function buildStyleClass (statusName: string): string {
  return `${ CHIP_BASE_STYLE_CLASS }--${ statusName }`;
}

@Component({
  selector: 'app-status-chip',
  standalone: true,
  imports: [ MatChipsModule, NgClass, TranslationPipeModule ],
  templateUrl: './status-chip.component.html',
  styleUrl: './status-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusChipComponent {
  public readonly statusType: InputSignal<StatusType> = input.required<StatusType>();

  public readonly value: InputSignal<string | undefined> = input<string>();

  public readonly translatedValue: InputSignal<TranslationInfo | undefined> = input<TranslationInfo>();

  protected readonly STATUS_TYPES: typeof STATUS_TYPES = STATUS_TYPES;

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  protected readonly chipClass: Signal<string> = computed(() => {
    switch (this.statusType()) {
      case STATUS_TYPES.success: {
        return buildStyleClass("success");
      }

      case STATUS_TYPES.error: {
        return buildStyleClass("error");
      }

      default: {
        return buildStyleClass("neutral");
      }
    }
  });
}
